import React, { useState, useEffect } from 'react'
import "./configurations.scss"
import { Tabs } from 'antd'
import ProductsConfigurations from './subtabs/products-configurations';
import TeamsConfigurations from './subtabs/teams-configurations';
import CoursesConfigurations from './subtabs/courses-configurations';
import { useLocation } from 'react-router-dom';

import { getRequest } from '../../api/http';
import userServiceApi from '../../api/userServiceApi';
import { toast } from 'react-toastify';

export default function MicrositeConfigurations() {
    const location = useLocation();
    const { state } = location;
    const micrositeId = state.micrositeId;
    const [activeKey, setActiveKey] = useState(state.page ? state.page : "product");
    const [tabListArray, setTabListArray] = useState([])

    const [tabIdKey, setTabIdKey] = useState({
        productKey: null,
        teamsKey: null,
        coursesKey: null,
    });

    const changeTab = (activeKey) => {
        setActiveKey(activeKey);
    }



    useEffect(() => {
        if(!micrositeId) return
        const getProSettings = async () => {
            try {
                const response = await getRequest(
                    userServiceApi.getMicroSiteTabConfig(micrositeId)
                );

                if (response?.data) {
                    setTabListArray(response.data);

                    const productTab = response.data.find(
                        (item) => item.displayName === "Products"
                    );
                    const teamsTab = response.data.find(
                        (item) => item.displayName === "Teams and Roles"
                    );
                    const coursesTab = response.data.find(
                        (item) => item.displayName === "Our Courses"
                    );

                    setTabIdKey({
                        productKey: productTab?.id || null,
                        teamsKey: teamsTab?.id || null,
                        coursesKey: coursesTab?.id || null,
                    });
                }
            } catch (error) {
                toast.error("Failed to fetch pro settings");
            }
        };

        const FetchProSettingsDelay = setTimeout(() => {
            getProSettings();
        }, 300);

        return () => {
            clearTimeout(FetchProSettingsDelay);
        };
    }, [micrositeId]);


    return (
        <div className="tabContainer">
            {/* <div className="header page-header">
                <div className="backbtn-container">
                    <img src={backArrow} alt="" onClick={() => navigate('/')} />
                    <p>Configurations</p>
                </div>
            </div> */}
            <Tabs onChange={changeTab} activeKey={activeKey}>
                <Tabs.TabPane tab="Products" key="product">
                    <ProductsConfigurations micrositeId={micrositeId} tabConfigId={tabIdKey.productKey} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Courses" key="courses">
                    <CoursesConfigurations micrositeId={micrositeId} tabConfigId={tabIdKey.coursesKey} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Teams" key="teams">
                    <TeamsConfigurations micrositeId={micrositeId} tabConfigId={tabIdKey.teamsKey} />
                </Tabs.TabPane>
            </Tabs>
        </div>
    )
}
